module.exports = __webpack_public_path__ + "img/stationery-products.f7498d40.jpg";